






























import Vue from 'vue'
import Component from 'vue-class-component'
import { State, Mutation } from 'vuex-class'
import { Notification } from '@/store/types';
import { notify, Colors } from '@/modules/core/notification'
import NotificationCard from '@/components/NotificationCard.vue'
// import { Notification } from '@/store/types';

/**
 * Centro de notificaciones
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: { NotificationCard },
})
export default class NotificationCenter extends Vue {
    public get visibility (): boolean {
        return this.$store.state.notification.center.visible || false
    }

    public set visibility (value: boolean) {
        this.$store.commit('showNotificationCenter', value)
    }

    @State(state => state.notification.center.stack)
    public stack: Notification[]

    @Mutation('clearNotificationStack')
    public clearNotificationStack: () => void

    public sendNotification () {
        notify('Notificar')
    }
}
